
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightFlashlight as ObiLightFlashlightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-flashlight.js';
 
 
 

 
 export const ObiLightFlashlight = createComponent({
   react: React,
   tagName: 'obi-light-flashlight',
   elementClass: ObiLightFlashlightElement,
   events: {
     
   }
  });
 
 